








import Vue from "vue";
import UsageHistoryGraph from "@/components/organisms/UsageHistoryGraph/index.vue";

export default Vue.extend({
  components: { UsageHistoryGraph },
  props: {
    data: Object,
  },
  data() {
    return {};
  },
  methods: {
    handleOnSearch(val: any) {
      this.$emit("getUsageHistory", val);
    },
  },
});
